import { Box, Stack, Typography } from "@mui/material";
import { usePostHog } from "posthog-js/react";
import { useNavigate } from "react-router-dom";

import { useCarrierCompanyBookingLimits, useRoleContext } from "hooks";
import { captureCarrierUpgradeCtaClicked } from "utils";

import {
  CARRIER_UPGRADE_RELATIVE_URL,
  CarrierUpgradeSource,
} from "../../../../constants";

export function CarrierEssentialsBookingRemainingBannerText() {
  const { company } = useRoleContext();
  const { limits } = useCarrierCompanyBookingLimits();
  const navigate = useNavigate();
  const posthog = usePostHog();

  const onClick = () => {
    captureCarrierUpgradeCtaClicked(
      posthog,
      CarrierUpgradeSource.ESSENTIALS_BOOKINGS_REMAINING_BANNER,
    );
    navigate(CARRIER_UPGRADE_RELATIVE_URL);
  };

  if (limits == null) {
    return null;
  }

  const getBookingsRemainingLabel = () => {
    const companyPrefix = company?.name ? `${company.name} has` : "You have";
    const displayCount = Math.max(limits.remainingBookings, 0);

    let countColor: string | undefined;
    if (limits.remainingBookings <= 0) {
      countColor = "red";
    } else if (limits.remainingBookings === 1) {
      countColor = "yellow";
    }

    const bookingNoun = displayCount === 1 ? "booking" : "bookings";

    return (
      <>
        {`${companyPrefix} `}
        <span style={countColor ? { color: countColor } : undefined}>
          {displayCount}
        </span>
        {` free non-partner ${bookingNoun} remaining`}
      </>
    );
  };

  return (
    <Box
      sx={{
        "&:hover": {
          cursor: "pointer",
        },
      }}
      onClick={onClick}
    >
      <Stack direction="column" alignItems="center">
        <Typography variant="h6" color="white">
          {getBookingsRemainingLabel()}
        </Typography>
      </Stack>
    </Box>
  );
}
